import { render, staticRenderFns } from "./PolicyDetailsPage.vue?vue&type=template&id=ccc4204a&"
import script from "./PolicyDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PolicyDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports